import querystring from "querystring";

import { IsoLocale, IS_SUPER_ADMIN_QUERY_PARAM, RoutePrefix, PublicRoutes } from "@simplyk/common";
import router from "next/router";

import { isReviewApp } from "../constants/env";
import { FRONTEND_URL } from "../routes/routes";

export const LOGIN_QUERY_PARAM_INVALID_EMAIL_FOR_GOOGLE_SSO = "invalid_email_for_google_sso";
export const LOGIN_QUERY_PARAM_AUTHENTICATION_FAILED = "authentication_failed";
export const LOGIN_QUERY_PARAM_GOOGLE_SSO_DISABLED = "google_sso_disabled";
export const LOGIN_QUERY_PARAM_GOOGLE_SSO_REENABLE_EXPIRED = "google_sso_reenable_expired";
export const LOGIN_QUERY_PARAM_MAGIC_LINK_FAILED = "magic_link_failed";

export const getDashboardReloadUrl = (path: string, isoLocale?: IsoLocale) =>
  `${FRONTEND_URL}${isoLocale ? "/" + isoLocale : ""}${path}`;

export const isOrganizationRoute = (path?: string) => path?.includes(`${RoutePrefix.Organization}/`);
export const isDonorRoute = (path?: string) => path?.includes(`${RoutePrefix.Donor}/`);
const publicAdminPaths = ["/admin/login", "/admin/magic-login"];
export const isAdminRoute = (path?: string) =>
  Boolean(path?.includes(`/admin/`)) && !publicAdminPaths.some((publicPath) => path?.includes(publicPath));

export const isPublicRoute = (path?: string) => {
  return (
    (!path?.includes(`${RoutePrefix.Donor}/`) && !path?.includes(`${RoutePrefix.Organization}/`)) ||
    // this case is to handle e-ticket QR codes before login migration
    path?.includes(`${RoutePrefix.Donor}/ticket/`)
  );
};

export const isPrivateRoute = (path?: string) => {
  return !isPublicRoute(path);
};

export const redirectAuthenticatedUserToLogout = ({
  connectedAsAdministrator,
  redirectionUrl,
}: {
  connectedAsAdministrator: boolean;
  redirectionUrl?: string;
}) => {
  // * Checking if router exists for serverside rendering cases
  if (!router || (!isOrganizationRoute(router.pathname) && !isDonorRoute(router.pathname))) {
    return;
  }

  // Use provided redirectionUrl or default to current page path
  const finalRedirectionUrl = redirectionUrl || router.asPath;

  if (isReviewApp) {
    const query = querystring.stringify({
      ...(isDonorRoute(router.pathname) ? { donor: true } : {}),
      redirectionUrl: finalRedirectionUrl,
    });
    return router.replace(`/review-app/login?${query}`);
  }

  const query = querystring.stringify({
    [IS_SUPER_ADMIN_QUERY_PARAM]: connectedAsAdministrator ? true : false,
    redirectionUrl: finalRedirectionUrl,
  });

  return router.push(`${PublicRoutes.SignOut}?${query}`);
};

export const redirectToLogout = (options: { connectedAsAdministrator: boolean; redirectionUrl?: string }) => {
  if (!router || isPublicRoute(router.pathname)) {
    return;
  }

  const redirectionUrl = options?.redirectionUrl;
  const query = querystring.stringify({
    [IS_SUPER_ADMIN_QUERY_PARAM]: options.connectedAsAdministrator ? true : false,
    redirectionUrl,
  });

  return router.push(`${PublicRoutes.SignOut}?${query}`);
};

export const redirectToLogin = (options?: { redirectionUrl?: string }) => {
  const redirectionUrl = options?.redirectionUrl;
  const urlQuery = redirectionUrl ? { redirectionUrl } : {};
  const query = querystring.stringify(urlQuery);

  return router.push(`${PublicRoutes.SignIn}?${query}`);
};
